export default __webpack_public_path__ + "a8ccf1413354931d57b04e84d1d0f2ab.png";